const trees = [
	{
		name: 'tree1',
		title: 'Maple',
		tooltip: 'Maple tree',
		props: {
			textureRef: 'tree1'
		}
	},
	{
		name: 'tree2',
		title: 'Birch',
		tooltip: 'Birch tree',
		props: {
			textureRef: 'tree2'
		}
	},
	{
		name: 'tree3',
		title: 'Aspen',
		tooltip: 'Aspen tree',
		props: {
			textureRef: 'tree3'
		}
	},
	{
		name: 'tree4',
		title: 'Pine',
		tooltip: 'Pine tree',
		props: {
			textureRef: 'tree4'
		}
	},
	{
		name: 'tree5',
		title: 'Spruce',
		tooltip: 'Spruce tree',
		props: {
			textureRef: 'tree5'
		}
	}, {
		name: 'tree6',
		title: 'Beech',
		tooltip: 'Beech tree',
		props: {
			textureRef: 'tree6'
		}
	}, {
		name: 'tree7',
		title: 'Alder',
		tooltip: 'Alder tree',
		props: {
			textureRef: 'tree7'
		}
	}
]
const bushes = [
	{
		name: 'bush1',
		title: 'Leafy bush 1',
		tooltip: 'Leafy bush 1',
		tool: 'bush',
		props: {
			textureRef: 'bush1'
		}
	},
	{
		name: 'bush2',
		title: 'Leafy bush 2',
		tooltip: 'Leafy bush 2',
		tool: 'bush',
		props: {
			textureRef: 'bush2'
		}
	},
	{
		name: 'bush3',
		title: 'Leafy bush 3',
		tooltip: 'Leafy bush 3',
		tool: 'bush',
		props: {
			textureRef: 'bush3'
		}
	},
	{
		name: 'bush4',
		title: 'Japaneze maple',
		tooltip: 'Japaneze maple',
		tool: 'bush',
		props: {
			textureRef: 'bush4'
		}
	},
	{
		name: 'bush5',
		title: 'Confer bush 1',
		tooltip: 'Confer bush 1',
		tool: 'bush',
		props: {
			textureRef: 'bush5'
		}
	},
	{
		name: 'bush6',
		title: 'Confer bush 2',
		tooltip: 'Confer bush 2',
		tool: 'bush',
		props: {
			textureRef: 'bush6'
		}
	}
]

let treeMenuItems = []
for (let t of trees) {
	treeMenuItems.push({
		name: t.name + 'small',
		title: '<div>' + t.title + '</div><div class="flex-1 w-3"></div><div>Small</div>',
		tooltip: t.tooltip,
		tool: 'tree',
		props: {
			...t.props,
			treeSize: 'small'
		}
	})
	treeMenuItems.push({
		name: t.name + 'large',
		title: '<div>' + t.title + '</div><div class="flex-1 w-3"></div><div>Large</div>',
		tooltip: t.tooltip,
		tool: 'tree',
		props: {
			...t.props,
			treeSize: 'big'
		}
	})
}
export const TreeSelectList = trees.sort((a, b) => a.title.localeCompare(b.title))
export const TreeDropDownMenu = treeMenuItems.sort((a, b) => a.title.localeCompare(b.title))
export const BushDropDownMenu = bushes
